import {createReducer} from '../utility'




export const signIn = createReducer({},{
    "CURRENT_USER"(state, {data}){
        if(data){
            return {
                ...state,
                currentUser: data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})


export const registration = createReducer({},{
    "SUBMIT_REGISTRATION_SUCCESSFUL"(state, {data}){
        if(data){
            return {
                ...state,
                registered: data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})



export const signinStatus = createReducer({},{
    "SIGNIN_STATUS"(state, {data}){
        if(data){
            return {
                ...state,
                status: data.data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})


export const registrationStatus = createReducer({},{
    "REGISTRATION_STATUS"(state, {data}){
        if(data){
            return {
                ...state,
                status: data.data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})

export const resetPassword = createReducer({},{
    "RESET_PASSWORD_SUCCESSFUL"(state, {data}){
        if(data){
            return {
                ...state,
                status: data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})

export const validateToken = createReducer({},{
    "HAS_VALIDATED_TOKEN"(state, {data}){
        if(data){
            return {
                ...state,
                token: data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})


export const changePassword = createReducer({},{
    "CHANGE_PASSWORD_SUCCESSFUL"(state, {data}){
        if(data){
            return {
                ...state,
                status: data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})


export const validateMemberAccount = createReducer({},{
    "HAS_ACTIVATED_MEMBER_ACCOUNT"(state, {data}){
        if(data){
            return {
                ...state,
                status: data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})


export const hasActivatedEmail = createReducer({},{
    "HAS_ACTIVATE_EMAIL"(state, {data}){
        if(data){
            return {
                ...state,
                status: data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})